import { render } from "./NewsDetail.vue?vue&type=template&id=07305b3c&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=07305b3c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07305b3c"]])

export default __exports__